import { useCallback, useEffect, useMemo, useRef } from "react";
import { useMeasurement } from "../../providers/NewMeasurementProvider";
import { useCanvasViewport } from "./CanvasViewportContext"
import { Point } from "./Geometry";
import { autoPlacement, offset, useFloating } from "@floating-ui/react";
import { Trash } from "@phosphor-icons/react";

export function ContextMenu() {
  const { measurementContextMenu, closeMeasurementContextMenu } = useCanvasViewport();
  const { deleteMeasurement } = useMeasurement();

  const { refs, floatingStyles, update } = useFloating({
    placement: 'right-start', // or whatever fits your UI
    middleware: [offset(10), autoPlacement()]
  });

  // Update the position whenever `canvasMousePosition` changes
  useEffect(() => {
    update();
  }, [measurementContextMenu, update]);

  const onMouseLeave = useCallback(() => {
    closeMeasurementContextMenu();
  }, [closeMeasurementContextMenu]);

  const handleDelete = useCallback(() => {
    closeMeasurementContextMenu();
    deleteMeasurement(measurementContextMenu.measurement!.key);
  }, [deleteMeasurement, measurementContextMenu, closeMeasurementContextMenu]);

  if (measurementContextMenu.active) {
    return (
      <div
        ref={refs.setFloating}
        style={{
          ...floatingStyles,
          left: `${measurementContextMenu.position!.x}px`,
          top: `${measurementContextMenu.position!.y}px`
        }}
        className="bg-white shadow-lg rounded-md p-2 z-1000 pointer-events-auto"
        onMouseLeave={onMouseLeave}
      >
        <div className="flex flex-col">
          <div className="text-gray-700 pl-1 font-mono">{measurementContextMenu.measurement!.key}</div>
          <hr className="my-2" />
          <button
            className="flex items-center text-red-600 hover:text-red-800 hover:bg-gray-100 p-2 rounded transition-colors duration-200"
            onClick={handleDelete}
          >
            <Trash size={16} className="mr-2" />
            Delete Measurement
          </button>
        </div>
      </div>
    )
  } else {
    return <div></div>
  }
}